import { getItem, checkIfResponseSuccess, getBaseItemResponseShape } from 'owa-mail-store';
import Item from 'owa-service/lib/contract/Item';
import ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import Message from 'owa-service/lib/contract/Message';
import { action } from 'satcheljs/lib/legacy';

let updateItemRecipients = function updateItemRecipients(originalItem: Item, responseItem: Item) {
    const existingItem: Message = originalItem;
    const newItem: Message = responseItem;
    existingItem.ToRecipients = newItem.ToRecipients;
    existingItem.CcRecipients = newItem.CcRecipients;
    existingItem.BccRecipients = newItem.BccRecipients;
};

updateItemRecipients = action('updateItemRecipients')(updateItemRecipients);

export default async function loadAllRecipientsForItem(item: Item): Promise<void> {
    const itemShape = getBaseItemResponseShape();
    itemShape.MaximumRecipientsToReturn = 0;

    const response = await getItem([item.ItemId.Id], itemShape, 'ItemPart');
    if (checkIfResponseSuccess(response[0])) {
        const responseItem = response[0] as ItemInfoResponseMessage;
        updateItemRecipients(item, responseItem.Items[0]);
    }
}
